module.exports = __webpack_public_path__ + "static/img/logo01.074ea9e3.png";